import React, { useEffect } from 'react';
import AboutSection1 from '../../components/about/AboutSection1';
import AboutSection2 from '../../components/about/AboutSection2';
import AboutSection3 from '../../components/about/AboutSection3';
import AboutSection4 from '../../components/about/AboutSection4';
import AboutSection5 from '../../components/about/AboutSection5';
import AboutSection6 from '../../components/about/AboutSection6';

const AboutPage = () => {
    useEffect(() => {
        document.title = '폰피쉬 소개 | 서비스 안내';
    }, []);

    return (
        <div className="w-full pt-[60px] md:pt-[80px] md:pt-0" style={{ backgroundColor: '#FEF1F9' }}>
            <AboutSection1 />
            <AboutSection2 />
            <AboutSection3 />
            <AboutSection4 />
            <AboutSection5 />
            <AboutSection6 />
        </div>
    );
};

export default AboutPage; 